<template>
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 12.0737L5 12.0737" stroke="#00BF8C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
